import React from 'react';
import { BookingButton } from './BookingButton';
export function Contact() {
  return <section id="contact" className="on-dark bg-forest text-paper" data-id="element-24" data-mp="358f22yl399hj">
      <div className="max-w-content mx-auto px-5 sm:px-6 lg:px-10 py-20 md:py-24" data-id="element-25" data-mp="35a9ibzlf0dfa">
        <div className="max-w-2xl mx-auto text-center" data-id="element-26" data-mp="316trxkzxv9b1">
          <p className="text-xs sm:text-[0.8125rem] uppercase tracking-[0.14em] font-medium text-sage-deep" data-id="element-27" data-mp="2w88ozdtaybiw">
            An introductory conversation
          </p>
          <h2 className="mt-4 font-serif text-3xl md:text-[2.75rem] leading-tight tracking-tight" data-id="element-28" data-mp="3szkd90g33dli">
            What needs to move forward?
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-sage-deep" data-id="element-29" data-mp="3k44pn15x9uod">
            Tell me what’s happening. We’ll use an initial conversation to explore the situation and
            whether I can help.
          </p>
          <BookingButton location="closing" variant="onDark" className="mt-9 w-full sm:w-auto" data-id="element-30" data-mp="ghw03uerocx0" />
          <p className="mt-4 text-sm text-sage-deep" data-id="element-31" data-mp="bo1jizugke25">Complimentary · 30 minutes · Google Meet</p>
        </div>
      </div>
    </section>;
}